import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }];
  return <nav className="fixed w-full bg-sum-light shadow-sm z-50" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <div className="flex justify-between h-20" data-id="element-141">
          <div className="flex-shrink-0 flex items-center" data-id="element-142">
            <a href="#" data-id="element-143">
              <img className="h-14 w-auto" src="https://cdn.magicpatterns.com/uploads/6cUEwm9nWDESrDmpRk3ub3/sum_logo.jpg" alt="SalesUp Marketing Logo" data-id="element-144" />
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-145">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sum-charcoal hover:text-sum-green font-medium transition-colors" data-id="element-146">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-sum-green text-white px-6 py-2.5 rounded-md font-semibold hover:bg-green-700 transition-colors shadow-sm" data-id="element-147">
              Contact Me
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-148">
            <button onClick={() => setIsOpen(!isOpen)} className="text-sum-charcoal hover:text-sum-green focus:outline-none" data-id="element-149">
              {isOpen ? <X size={28} data-id="element-150" /> : <Menu size={28} data-id="element-151" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-sum-light border-t border-gray-100 shadow-lg absolute w-full" data-id="element-152">
          <div className="px-4 pt-2 pb-6 space-y-1 sm:px-3 flex flex-col" data-id="element-153">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-3 text-base font-medium text-sum-charcoal hover:text-sum-green hover:bg-gray-50 rounded-md" data-id="element-154">
                {link.name}
              </a>)}
            <a href="#contact" onClick={() => setIsOpen(false)} className="block px-3 py-3 mt-4 text-center text-base font-bold text-white bg-sum-green rounded-md hover:bg-green-700" data-id="element-155">
              Contact Me
            </a>
          </div>
        </div>}
    </nav>;
}